import React from 'react';
import { Show, SimpleShowLayout, required, number, minValue, maxValue, AutocompleteInput, Toolbar, SaveButton,
	AutocompleteArrayInput, BooleanInput, NumberField, DateField, NumberInput, TabbedForm, FormTab,
	SelectArrayInput, ArrayInput, SimpleFormIterator, Edit, Create, EditButton, Filter, List, Datagrid, TextField,
	TextInput, ReferenceArrayInput, ReferenceInput, SelectInput, BooleanField, ReferenceField, ReferenceArrayField,
	SingleFieldList, ChipField, ArrayField, FormDataConsumer, Labeled, usePermissions } from 'react-admin';
import { Box, Card, CardContent, CardHeader, Typography, Divider } from '@material-ui/core';
import {
  SiteFilter, TopLevelDomainFilter, PublisherFilter, DeviceTypeFilter, OSFilter,
  IABCategoriesFilter, PageUrlFilter, CountryFilter, StateFilter,
  AdSizeFilter, DivIDFilter, ViewabilityFilter, BidderFilter, ImpressionTypeFilter, ChannelFilter,
  HttpHeaderFilter, CookiesFilter, MediaCategoriesFilter, IpListsFilter, AsnFilter, AdvertiserFilter, UserAgentFilter,
	PlacementFilter, MultipleChoiceFilter, SegmentFilter, regionChoices, browserChoices
} from './common/filters/Filters';
import { makeStyles } from '@material-ui/core/styles';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import { CopyIconButton, CopyButton } from './components/CopyButton';

const {validFrequencyCap, validFrequencyHours} = require('./components/validation.js');
const utils = require('./components/utils');
const { SectionHeader } = require('./components/utils');

const CampaignTitle = ({ record }) => {
	return <span>Traffic Rule {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

const CampaignFilter = ({ permissions, ...props }) => (
	<Filter {...props}>
		<TextInput label="Search" source="search_name" alwaysOn resettable />
		<BooleanInput source="active" label="Active" style={{}} alwaysOn resettable />
		<BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{}} resettable />
		<ReferenceArrayInput source="bidder_id" label="Bidders" allowEmpty={false}
			reference="bidders"
			basePath='Bidders'
			perPage={10}
			sort={{ field: 'name', order: 'ASC' }}
			filterToQuery={searchText => ({ search_name: searchText })}>
			<AutocompleteArrayInput label="Bidders" optionText={record => {return (record && record.code) ? `${record.name} (${record.code})` : ''}} optionValue="code" fullWidth/>

		</ReferenceArrayInput>
		<SelectArrayInput style={{ width: '160px' }} label="Type" source="campaign_type" choices={[
			{ id: 'price_rules', name: 'Price Rules' },
			{ id: 'crt_ext', name: 'Creative Extensions' }
		]} />

		<ReferenceArrayInput source="experiment_id" label="Experiments" allowEmpty={false}
			reference="experiments"
			basePath='Experiments'
			perPage={10}
			sort={{ field: 'name', order: 'ASC' }}
			filterToQuery={searchText => ({ search_name: searchText })}>
		<AutocompleteArrayInput label="Experiments" optionText={record => {return (record && record.code) ? `${record.name} (${record.code})` : ''}} optionValue="code" fullWidth/>

		</ReferenceArrayInput>

		<BooleanInput source="block_traffic" defaultValue='true' label="Block Trafic" style={{}} resettable />

	</Filter>
);
const SettingsArrayField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (!record[field]) return <div />;
	var arr = record[field].split('\n');
	return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label}</span>
			</label>
			<br />
			<span className="MuiTypography-root MuiTypography-body2">
				{arr.length > 5 ? (arr.splice(0, 5).join(' ') + ' ...') : arr.join(' ')}
			</span>
		</div>)
}
const FilterArrayField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (!record.segment || !record.segment[field] || !record.segment[field].values || record.segment[field].values.length <= 0) return <div />;
	var arr = record.segment[field].values.split('\n');
	return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} ({record.segment[field] && record.segment[field].exclude ? 'Exclude' : 'Include'})</span>
			</label>
			<br />
			<span className="MuiTypography-root MuiTypography-body2">
				{arr.length > 5 ? (arr.splice(0, 5).join(' ') + ' ...') : arr.join(' ')}
			</span>
		</div>
	)
}
const BlockedAttributesField = ({ record }) => (
	<div>
		<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
			<span>Blocked Attributes</span>
		</label>
		<br />
		{record.battr.map(item => (
			<li key={ATTRIBUTES[item]}>{ATTRIBUTES[item]}</li>
		))}
	</div>
)
const SettingsListField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	// SettingsListField Blocked Advertiser Categories BlockedAdCategoriesField
	if (!record[field]) return <div />;
	return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label}</span>
			</label>
			<br />
			{record[field].map((item, index) => {
				if (index < 5)
					return (
						<li key={item}>{item}</li>
					)
			}
			)}
		</div>
	)
}
const FilterListField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (record.segment && record.segment[field] && record.segment[field].values && record.segment[field].values.length > 0) return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} ({record.segment[field].exclude ? 'Exclude' : 'Include'})</span>
			</label>
			<ul>
				{record.segment[field].values.map(item => (
					<li key={item}>{item}</li>
				))}
			</ul>
		</div>
	)
	return <div />
}
const ATTRIBUTES = {
	1: 'Audio Ad (Auto-Play) (1)',
	2: 'Audio Ad (User Initiated) (2)',
	3: 'Expandable (Automatic) (3)',
	4: 'Expandable (User Initiated - Click) (4)',
	5: 'Expandable (User Initiated - Rollover) (5)',
	6: 'In-Banner Video Ad (Auto-Play) (6)',
	7: 'In-Banner Video Ad (User Initiated) (7)',
	8: 'Pop (e.g., Over, Under, or Upon Exit) (8)',
	9: 'Provocative or Suggestive Imagery (9)',
	10: 'Shaky, Flashing, Flickering, Extreme Animation, Smileys (10)',
	11: 'Surveys (11)',
	12: 'Text Only (12)',
	13: 'User Interactive (e.g., Embedded Games) (13)',
	14: 'Windows Dialog or Alert Style (14)',
	15: 'Has Audio On/Off Button (15)',
	16: 'Ad Provides Skip Button (e.g. VPAID-rendered skip button on pre-roll video) (16)',
	17: 'Adobe Flash (17)'
}
const checkPriceRules = (priceRules, rule_name) => {
	if (!priceRules) return false;
	if (!priceRules[rule_name]) return false;
	return true;
}
const checkFilter = (filter) => {
	if (!filter) return false
	if (Array.isArray(filter.values) && filter.values.length > 0)
		return true;
	return false
}

const CampaignPreview = ({record, ...props}) => {
	return (
		<Show {...props} actions={false}>
			<SimpleShowLayout>
				{record.frequency_cap != null &&
					<span>Frequency Cap</span>}
				{record.frequency_cap != null &&
					<NumberField label="Cap" source="frequency_cap.cap" />}
				{record.frequency_cap != null && <NumberField label="Hours" source="frequency_cap.hours" />}
				{record.bidder_id != null && <ReferenceField label="Bidder" source="bidder_id" reference="bidders">
					<TextField source="name" />
				</ReferenceField>}
				{record.hard_floor != null && <NumberField source="hard_floor" label="Hard Floor" style={{ width: '400px' }} />}
				{record.revshare != null && <NumberField source="revshare" label="Platform Revshare" style={{ width: '400px' }} />}
				{record.revshare_random_min != null && <NumberField source="revshare_random_min" label="Platform Revshare Minimum. Default value 10." style={{ width: '400px' }} />}
				{record.revshare_random_max != null && <NumberField source="revshare_random_max" label="Platform Revshare Maximum. Default value 30." style={{ width: '400px' }} />}
				{record.revshare_model_enabled != null && <BooleanField source="revshare_model_enabled" label="Revshare Optimizer Model Enabled" style={{ width: '400px' }} />}
				{record.auction_optimizer_disabled != null && <BooleanField source="auction_optimizer_disabled" label="Auction Optimizer Disabled" style={{ width: '400px' }} />}
				{record.refresh_limit != null && <NumberField source="refresh_limit" label="Refresh Limit" style={{ width: '400px' }} />}
				{record.user_block_expire_hours != null && <NumberField source="user_block_expire_hours" label="User Limit (Hours)" style={{ width: '400px' }} />}
				{record.block_traffic != null && <BooleanField source="block_traffic" label="Block Traffic" style={{ width: '400px' }} />}
				{record.domain_ivt_block_enabled != null && <BooleanField source="domain_ivt_block_enabled" label="Block IVT Domains" style={{ width: '400px' }} />}
				{/* {record.fast_lane_enabled != null && <BooleanField source="fast_lane_enabled" style={{ width: '30%' }} label="Enable Fast Lane" />} */}
				{record.event_streaming_enabled != null && <BooleanField source="event_streaming_enabled" label="Enable Event Logs (Advanced)" style={{ width: '400px' }} />}
				{record.adrequest_streaming_enabled != null && <BooleanField source="adrequest_streaming_enabled" label="Enable Ad Request Logs (Advanced)" style={{ width: '400px' }} />}

				{record.floor_bandit_enabled != null && <BooleanField source="floor_bandit_enabled" label="ML Floor Bandit" style={{ width: '400px' }} />}

				{record.referer_defaulting_enabled != null && <BooleanField source="referer_defaulting_enabled" label="Referer Defaulting" style={{ width: '400px' }} />}

				{record.experiment_id != null && <ReferenceField source="experiment_id" label="Experiments" reference="experiments">
					<TextField source="name" />
				</ReferenceField>}

				{checkFilter(record.segment.filter_publisher) && <ReferenceArrayField source="segment.filter_publisher.values" label="Publishers Filtered" reference="publishers">
					<SingleFieldList>
						<ChipField source="name" />
					</SingleFieldList>
				</ReferenceArrayField>}
				{checkFilter(record.segment.filter_site) &&
					<ReferenceArrayField source="segment.filter_site.values" label="Sites Filtered" reference="sites">
						<SingleFieldList>
							<ChipField source="name" />
						</SingleFieldList>
					</ReferenceArrayField>}
				{checkFilter(record.segment.filter_network) &&
					<ReferenceArrayField source="segment.filter_network.values" label="Networks Filtered" reference="networks">
						<SingleFieldList>
							<ChipField source="name" />
						</SingleFieldList>
					</ReferenceArrayField>}
				{<FilterArrayField field='filter_top_level_domain' label='Filter Domains' />}
				{<FilterArrayField field='filter_asn' label='Filter ASN Numbers' />}
				{<FilterArrayField field='filter_page_url' label='Filter Page URLs' />}
				{<FilterListField field='filter_country' label='Filter Countries' />}
				{<FilterListField field='filter_state' label='Filter States' />}
				{<FilterListField field='filter_device_type' label='Filter Devices' />}
				{<FilterListField field='filter_os' label='Filter Operating Systems' />}
				{<FilterArrayField field='filter_adsize' label='Filter Ad Sizes' />}
				{<FilterArrayField field='filter_divid' label='Filter Div IDs' />}
				{<FilterListField field='filter_viewability' label='Filter Viewability' />}
				{checkFilter(record.segment.filter_bidder) && <ReferenceArrayField source="segment.filter_bidder.values" label="Bidders Filtered" reference="bidders">
					<SingleFieldList>
						<ChipField source="name" />
					</SingleFieldList>
				</ReferenceArrayField>}

				{<FilterListField field='filter_impression_type' label='Filter Impression Type' />}
				{<FilterListField field='filter_channel' label='Filter Channel' />}
				{<FilterListField field='filter_header' label='Filter HTTP Headers' />}
				{<FilterListField field='filter_cookie' label='Filter Cookies' />}

				{record.battr && <BlockedAttributesField />}

				{<SettingsArrayField field='badv' label='Blocked Advertisers' />}

				{<SettingsListField field='bcat' label='Blocked Advertiser Categories' />}

				{checkPriceRules(record.price_rules, 'first_price_scale') &&
					<NumberField source="price_rules.first_price_scale" label="Price Adjustment" />}
				{checkPriceRules(record.price_rules, 'second_price_scale') &&
					<NumberField source="price_rules.second_price_scale" label="Second Price Adjustment" />}
				{checkPriceRules(record.price_rules, 'auction_price_scale') &&
					<NumberField source="price_rules.auction_price_scale" label="Auction Price Adjustment" />}
				{checkPriceRules(record.price_rules, 'price_level_scale') &&
					<NumberField source="price_rules.price_level_scale" label="Price Level Adjustment" />}
				{checkPriceRules(record.price_rules, 'second_price_scale_relative_to_first') &&
					<NumberField source="price_rules.second_price_scale_relative_to_first" label="Second Price Adjustment Relative to First" />}
					//todo
				{record.tags &&
					<ArrayField source="tags" label="Creative Extensions">
						<Datagrid>
							<TextField source="name" />
							<TextField source="description" />
						</Datagrid>
					</ArrayField>}
			</SimpleShowLayout>
		</Show>
	)
}
export const CampaignList = (props) => (
	<List {...props} title="Trafic Rules" 
	filters={<CampaignFilter />} 
	perPage={25} bulkActionButtons={false}>
		<Datagrid rowClick="edit" expand={<CampaignPreview />}>
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			<TextField source="pace" label="Pace" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<BooleanField source="active" label="Active" />
			<CopyButton resource="campaigns" />
			<DeleteWithConfirmation />
		</Datagrid>
	</List>
);

const useStyles = makeStyles({
  dualGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px'
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  }
});


const twoColumnGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px', width: '50%' };
const fullWidth = { gridColumn: '1 / -1' };

const Filters = (props) => {
  const classes = useStyles(props);
  const { permissions } = usePermissions();
  const filterProps = { ...props, permissions: permissions || {} };
  return (
    <Box className={classes.dualGrid} fullWidth record={props.record}>
      <Box className={classes.flexColumn} fullWidth>
        <PublisherFilter {...filterProps}/>
        <SiteFilter {...filterProps}/>
        <TopLevelDomainFilter {...filterProps}/>
        <PageUrlFilter {...filterProps}/>
        <CountryFilter {...filterProps}/>
        <StateFilter {...filterProps}/>
        <DeviceTypeFilter {...filterProps}/>
				<OSFilter {...filterProps}/>
				<MultipleChoiceFilter {...filterProps} title='Browsers' filterName='filter_browser' matchType='equalsIgnoreCase'
				matchTypeHidden={true} choices={browserChoices} />
				<AdSizeFilter {...filterProps}/>
        <DivIDFilter {...filterProps}/>
				<PlacementFilter {...filterProps}/>
				<ViewabilityFilter {...filterProps}/>
				<AdvertiserFilter {...filterProps}/>

      </Box>
      <Box className={classes.flexColumn} fullWidth>
		    <IABCategoriesFilter {...filterProps}/>
		    <MediaCategoriesFilter {...filterProps}/>
        <BidderFilter {...filterProps}/>
        <ImpressionTypeFilter {...filterProps}/>
        <ChannelFilter {...filterProps}/>
        <HttpHeaderFilter {...filterProps}/>
        <CookiesFilter {...filterProps}/>
        <IpListsFilter {...filterProps}/>
        <AsnFilter {...filterProps}/>
				<MultipleChoiceFilter {...filterProps} title='Regions' filterName='filter_region' matchType='equalsIgnoreCase'
				matchTypeHidden={true}
				choices={regionChoices} />
				<UserAgentFilter {...filterProps} />
				<MultipleChoiceFilter {...filterProps} title='Endpoint Filter' filterName='filter_endpoint' matchType='equalsIgnoreCase'
				matchTypeHidden={true}
				choices={[
					{id:'post_adreq', name: 'POST Ad Request / Prebid'},
					{id:'get_adreq', name: 'GET Ad Request / Tag'},
					{id:'post_ortb', name: 'POST oRTB / S2S'},
				]} />
				<SegmentFilter {...filterProps}/>
      </Box>
    </Box>
  );
}

const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
		<CopyButton resource="campaigns" record={props.record} />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const validateDays = [number(), minValue(1), maxValue(7)];
export const CampaignEdit = (props) => (
	<Edit title={<CampaignTitle />} mutationMode="pessimistic" record={props.record} {...props}>
		<TabbedForm toolbar={<CustomToolbar />}>
			<FormTab label="Settings">
				<Box style={twoColumnGrid}>
					<SectionHeader title="General" />
					<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />
					<Labeled label="Campaign ID">
						<TextField source="code" style={{ fontSize: '1rem' }} />
					</Labeled>
					<TextInput source="name" label="Traffic Rule Name" style={{ maxWidth: 256 }} validate={required()} />
					<SelectInput label="Pace" source="pace" allowEmpty helperText="Campaign pace." choices={utils.PACES} style={{ maxWidth: 256 }} />

					<SectionHeader title="Frequency Capping" />
					<NumberInput label="Cap" source="frequency_cap.cap" min={0} step={1} validate={validFrequencyCap} style={{ maxWidth: 256 }} />
					<NumberInput label="Hours" source="frequency_cap.hours" min={0} max={168} step={1} validate={validFrequencyHours} style={{ maxWidth: 256 }} />

					<SectionHeader title="Bidder & Pricing" />
					<ReferenceInput label="Bidder"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{ hidden: false }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="bidder_id"
						reference="bidders"
						basePath='bidders'
						allowEmpty emptyText="- None -">
						<AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" style={{ maxWidth: 256 }} />
					</ReferenceInput>
					<NumberInput label="Bid Price" source={'bid_price'} helperText="Bid Price." style={{ maxWidth: 256 }} />
					<NumberInput source="hard_floor" label="Hard Floor" helperText="Any price or prediction below this value will be rejected. In US Dollars $." style={{ maxWidth: 256 }} />
					<utils.AuctionTypeSelectInput style={{ maxWidth: 256 }} />
					<ReferenceArrayInput label="Block Bidders"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{ hidden: false }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="block_bidders"
						reference="bidders"
						basePath='bidders'
						allowEmpty emptyText="- None -">
						<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
							optionValue="code" helperText="Block all requests to this list of Bidders." style={{ maxWidth: 256 }} />
					</ReferenceArrayInput>

					<SectionHeader title="Revshare" />
					<NumberInput source="revshare" label="Platform Revshare" helperText="Revshare taken out from the Publisher's revenue. 30 means 30% for the platform and 70% for the Publisher." style={{ maxWidth: 256 }} />
					<BooleanInput source="revshare_model_enabled" label="Revshare Optimizer Model Enabled" helperText="Revshare taken out from the Publisher's revenue between 10% and 30%." />
					<FormDataConsumer>
						{({ formData }) => formData && formData.revshare_model_enabled &&
							<Box style={{ ...fullWidth, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px' }}>
								<NumberInput source="revshare_random_min" label="Learning Minimum Revshare" defaultValue={10} helperText="Revshare minimum value taken out from the Publisher's revenue. Default value 10." validate={minValue(1)} style={{ maxWidth: 256 }}/>
								<NumberInput source="revshare_random_max" label="Learning Maximum Revshare" defaultValue={30} helperText="Revshare maximum value taken out from the Publisher's revenue. Default value 30." validate={maxValue(50)} style={{ maxWidth: 256 }}/>
								<ReferenceInput label="Learning Experiment"
									perPage={15}
									sort={{ field: 'name', order: 'ASC' }}
									filterToQuery={searchText => ({ search_name: searchText })}
									source="revshare_model_learning_experiment_id"
									reference="experiments"
									basePath='experiments'
									allowEmpty
									emptyText="- None -">
									<SelectInput optionText="name" optionValue="code" style={{ maxWidth: 256 }}/>
								</ReferenceInput>
							</Box>
						}
					</FormDataConsumer>

					<SectionHeader title="Traffic Controls" />
					<NumberInput source="refresh_limit" label="Refresh Limit" helperText="Limit the number of refreshes per page." style={{ maxWidth: 256 }} />
					<NumberInput source="user_block_expire_hours" label="User Limit (Hours)" helperText="Limit the number of Ad Requests for a user. This value is in hours. 1 means that the user is limited to 1 Ad Request per hour." style={{ maxWidth: 256 }} />
					<BooleanInput source="block_traffic" label="Block Traffic" helperText="Block traffic and do not respond with any bids or predictions." />
					<BooleanInput source="domain_ivt_block_enabled" label="Block IVT Domains" helperText="Block IVT traffic by domain. Only valid for CTV traffic." />
					<SectionHeader title="Feature Flags" />
					{/* <BooleanInput source="fast_lane_enabled" label="Enable Fast Lane" helperText="Fast lane enables for faster ad rendering by skipping GAM/DFP. Use this flag with caution b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google." /> */}
					<BooleanInput source="event_streaming_enabled" label="Enable Event streaming (Advanced)" helperText="Enable streaming of events to Main stream." />
					<BooleanInput source="adrequest_streaming_enabled" label="Enable Ad Request streaming (Advanced)" helperText="Enable streaming for Ad Requests to Main stream." />
					<BooleanInput source="ad_request_log_enabled" label="Enable Ad Request Logs (Advanced)" helperText="Enable logging of incoming Ad Requests in RTB stream for debugging purposes." />
					{/* <BooleanInput source="auction_log_enabled" label="Enable Auction Logs (Advanced)" helperText="Enable logging of Bid Requests and Bid Responses in RTB stream for debugging purposes." /> */}
					<BooleanInput source="iiq_s2s_enabled" label="Enable IntentIQ S2S" helperText="Enable IntentIQ S2S. Note that it does not apply to Bidders filter." />
					<BooleanInput source="extended_user_ids_disabled" label="Disable Extended User IDs (Advanced)" helperText="Disable Extended User IDs (Advanced)." />
					<BooleanInput source="dynamic_floor_enabled" label="Enable Dynamic floors (Advanced)" helperText="Enable Dynamic floors (Advanced)." />
					<BooleanInput source="auction_optimizer_disabled" label="Disable Auction Optimizer (Advanced)" helperText="Disable Auction Optimizer." />
					<BooleanInput source="self_compete_disabled" label="Disable Self Competition (Advanced)" helperText="Disable Sending Bid Requests if Supply Chain contains the platform ID." />
					<BooleanInput source="floor_bandit_enabled" label="Enable Dynamic Floor Bandit" helperText="Enable Dynamic Floor Bandit experiment. Requires an Experiment and Publisher filter to be configured." />
					<BooleanInput source="referer_defaulting_enabled" label="Enable Referer Defaulting" helperText="Enable referer defaulting experiment. Requires an Experiment to be configured." />
					<BooleanInput source="video_pod_enabled" label="Enable Video Ad Pods" helperText="Serve the top 2 video bids as one sequenced VAST pod instead of discarding the runner-up. Applies to prebid.js client requests; never to GAM-partner requests, and to OpenRTB only when the OpenRTB flag below is also on. Scoped by this rule's targeting - one enabled rule pods every video bid on a matching request, so slot 2 may go to any bidder. Player support varies and is undocumented by any vendor - watch slot-2 render rate after enabling. Clearing this is the kill switch." />
					<BooleanInput source="video_pod_ortb_enabled" label="Enable Video Ad Pods on OpenRTB" helperText="Extends pods to the OpenRTB endpoints, which are excluded by default. There the pod is copied straight into bid.adm: a caller that asked for one ad per imp may reject a multi-Ad creative and lose the WHOLE bid, not just slot 2, and it books one impression at whatever price we report however many ads play. Prove slot-2 render rate on prebid.js first, then enable here with First price pricing. No effect unless Enable Video Ad Pods is also on." />
					<SelectInput source="video_pod_pricing_mode" label="Video Pod Pricing" allowEmpty helperText="First price reports only the winning bid, crediting the publisher exactly what they get today with no revenue exposed if slot 2 never renders - the safe default for a first test. Compound reports P1+P2, giving the publisher the pod upside while NoBid carries the risk that slot 2 doesn't render. On OpenRTB, Compound also prices the bid itself on two renders the caller will never confirm. Leave empty for first price." choices={utils.POD_PRICING_MODES} style={{ maxWidth: 256 }} />

					<SectionHeader title="Experiment" />
					<ReferenceInput label="Experiment"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="experiment_id"
						reference="experiments"
						basePath='experiments'
						allowEmpty
						emptyText="- None -">
						<SelectInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) at ${record.pace}%` : ""} optionValue="code" style={{ maxWidth: 256 }}/>
					</ReferenceInput>
				</Box>
			</FormTab>

			<FormTab label="Filters" record={props.record}>
        <Filters {...props}/>
			</FormTab>

			<FormTab label="Creative Settings">
				<Card style={{ width: '100%' }} raised>
					<CardHeader title="Creative Settings" />
					<CardContent>

						<ReferenceArrayInput label="Creative"
							perPage={15}
							sort={{ field: 'name', order: 'ASC' }}
							filterToQuery={searchText => ({ search_name: searchText })}
							source="creatives"
							reference="creatives"
							basePath='creatives'
						>
							<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) [${record.adsize}]` : ""} optionValue="code" style={{ width: '50%' }} />
						</ReferenceArrayInput>

					</CardContent>
				</Card>
			</FormTab>

			<FormTab label="Price Rules">
				<NumberInput source="price_rules.first_price_scale" label="Price Adjustment" helperText="The prediction first price is multiplied by this number." />
				<NumberInput source="price_rules.second_price_scale" label="Second Price Adjustment" helperText="The prediction second price is multiplied by this number." />
				<NumberInput source="price_rules.auction_price_scale" label="Auction Price Adjustment" helperText="The price we send to the client (Prebid or Platform Tag) is multiplied by this number." />
				<NumberInput source="price_rules.price_level_scale" label="Price Level Adjustment" helperText="The price we send to GAM/DFP is multiplied by this number." />
				<NumberInput source="price_rules.second_price_scale_relative_to_first" label="Second Price Adjustment Relative to First" style={{ width: '400px' }} />
			</FormTab>

			<FormTab label="Creative Extensions">
				<BooleanInput
					source="malware_protection_tag"
					label="Malware Protection Tag."
					style={{ width: '400px' }}
				/>
				<ArrayInput source="tags">
					<SimpleFormIterator>
						<TextInput source="name" label="Name" validate={required()} style={{ width: '400px' }} />
						<TextInput source="description" label="description" multiline style={{ width: '400px' }} />
						<SelectInput label="Position relative to the creative" choices={
							[
								{ id: 'PREPEND', name: 'Before creative' },
								{ id: 'APPEND', name: 'After creative' }
							]
						}
							source="position"
						/>
						<br />
						<h5 style={{ width: '90%' }}>
							Double-quotes are not allowed in the content. Please escape them or use single quotes when possible.
		    	</h5>
						<div style={{ width: '90%' }}>Available Macros:<br />
		    	DIV_ID, ADUNIT_PATH, AD_SIZE, AD_SIZES, AD_SIZE_STRING, AD_SIZES_CLEANED, BIDDER_ID, BIDDER_NAME, PRICE, PRICE_BUCKET, BID_ID, SLOT_ID, CHANNEL_ID, BIDDER_SIZE_ID, BIDDER_SITE_ID, WIDTH, HEIGHT, SITE, PLACEMENT, PUBLISHER, ENVIRONMENT, PAGE_URL, IMPRESSION_TYPE, COPPA_SNIPPET, CHANNEL, PAGE_LOCATION, RANDOM, REGION, CREATIVE_ID, ADVERTISER_DOMAIN
		    	</div>
						<TextInput multiline label="Tag HTML content"
							validate={required()}
							source="content"
							helperText="Tag content in HTML format"
							style={{ width: '90%' }}
						/>
					</SimpleFormIterator>
				</ArrayInput>
			</FormTab>

		</TabbedForm>
	</Edit>
);

export const CampaignCreate = (props) => {
	const { permissions } = usePermissions();
	return (
	<Create title="Create Traffic Rule" mutationMode="pessimistic" {...props}>
		<TabbedForm toolbar={<CustomToolbar />}>
			<FormTab label="Settings">
				<Box style={twoColumnGrid}>
					<SectionHeader title="General" />
					{permissions && permissions.role === 'super_admin' &&
						<ReferenceInput label="Organization (leave empty for cross-org)" source="organization_id" reference="organizations" allowEmpty emptyText="- Cross-Org -" perPage={100} sort={{ field: 'name', order: 'ASC' }}>
							<AutocompleteInput optionText="name" optionValue="code" style={{ maxWidth: 256 }} />
						</ReferenceInput>
					}
					<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} />
					<Labeled label="Campaign ID">
						<TextField source="code" style={{ fontSize: '1rem' }} />
					</Labeled>
					<TextInput source="name" label="Traffic Rule Name" style={{ maxWidth: 256 }} validate={required()} />
					<SelectInput label="Pace" source="pace" allowEmpty helperText="Campaign pace." choices={utils.PACES} style={{ maxWidth: 256 }} />

					<SectionHeader title="Bidder & Pricing" />
					<ReferenceInput label="Bidder"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{ hidden: false }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="bidder_id"
						reference="bidders"
						basePath='bidders'
						allowEmpty emptyText="- None -">
						<AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" style={{ maxWidth: 256 }} />
					</ReferenceInput>
					<NumberInput label="Bid Price" source={'bid_price'} helperText="Bid Price." style={{ maxWidth: 256 }} />
					<NumberInput source="hard_floor" label="Hard Floor" helperText="Any price or prediction below this value will be rejected. In US Dollars $." style={{ maxWidth: 256 }} />
					<utils.AuctionTypeSelectInput style={{ maxWidth: 256 }} />
					<ReferenceArrayInput label="Block Bidders"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filter={{ hidden: false }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="block_bidders"
						reference="bidders"
						basePath='bidders'
						allowEmpty emptyText="- None -">
						<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
							optionValue="code" helperText="Block all requests to this list of Bidders." style={{ maxWidth: 256 }} />
					</ReferenceArrayInput>

					<SectionHeader title="Revshare" />
					<NumberInput source="revshare" label="Platform Revshare" helperText="Revshare taken out from the Publisher's revenue. 30 means 30% for the platform and 70% for the Publisher." style={{ maxWidth: 256 }} />
					<BooleanInput source="revshare_model_enabled" label="Revshare Optimizer Model Enabled" helperText="Revshare taken out from the Publisher's revenue between 10% and 30%." />
					<FormDataConsumer>
						{({ formData }) => formData && formData.revshare_model_enabled &&
							<Box style={{ ...fullWidth, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px' }}>
								<NumberInput source="revshare_random_min" label="Learning Minimum Revshare" defaultValue={10} helperText="Revshare minimum value taken out from the Publisher's revenue. Default value 10." validate={minValue(1)} style={{ maxWidth: 256 }}/>
								<NumberInput source="revshare_random_max" label="Learning Maximum Revshare" defaultValue={30} helperText="Revshare maximum value taken out from the Publisher's revenue. Default value 30." validate={maxValue(50)} style={{ maxWidth: 256 }}/>
								<ReferenceInput label="Learning Experiment"
									perPage={15}
									sort={{ field: 'name', order: 'ASC' }}
									filterToQuery={searchText => ({ search_name: searchText })}
									source="revshare_model_learning_experiment_id"
									reference="experiments"
									basePath='experiments'
									allowEmpty
									emptyText="- None -">
									<SelectInput optionText="name" optionValue="code" style={{ maxWidth: 256 }}/>
								</ReferenceInput>
							</Box>
						}
					</FormDataConsumer>

					<SectionHeader title="Traffic Controls" />
					<NumberInput source="refresh_limit" label="Refresh Limit" helperText="Limit the number of refreshes per page." style={{ maxWidth: 256 }} />
					<NumberInput source="user_block_expire_hours" label="User Limit (Hours)" helperText="Limit the number of Ad Requests for a user. This value is in hours. 1 means that the user is limited to 1 Ad Request per hour." style={{ maxWidth: 256 }} />
					<BooleanInput source="block_traffic" label="Block Traffic" helperText="Block traffic and do not respond with any bids or predictions." />
					<BooleanInput source="domain_ivt_block_enabled" label="Block IVT Traffic" helperText="Block IVT by Domain. Only for CTV." />
					<SectionHeader title="Feature Flags" />
					{/* <BooleanInput source="fast_lane_enabled" label="Enable Fast Lane" helperText="Fast lane enables for faster ad rendering by skipping GAM/DFP. Use this flag with caution b/c this will eliminate Google Dynamic Allocation revenue. Only use for sites that are not approved on Google." /> */}
					<BooleanInput source="event_streaming_enabled" label="Enable Event streaming (Advanced)" helperText="Enable streaming of events to Main stream." />
					<BooleanInput source="adrequest_streaming_enabled" label="Enable Ad Request streaming (Advanced)" helperText="Enable streaming for Ad Requests to Main stream." />
					<BooleanInput source="ad_request_log_enabled" label="Enable Ad Request Logs (Advanced)" helperText="Enable logging of incoming Ad Requests in RTB stream for debugging purposes." />
					{/* <BooleanInput source="auction_log_enabled" label="Enable Auction Logs (Advanced)" helperText="Enable logging of Bid Requests and Bid Responses in RTB stream for debugging purposes." /> */}
					<BooleanInput source="iiq_s2s_enabled" label="Enable IntentIQ S2S" helperText="Enable IntentIQ S2S. Note that it does not apply to Bidders filter." />
					<BooleanInput source="extended_user_ids_disabled" label="Disable Extended User IDs (Advanced)" helperText="Disable Extended User IDs (Advanced)." />
					<BooleanInput source="auction_optimizer_disabled" label="Disable Auction Optimizer (Advanced)" helperText="Disable Auction Optimizer." />
					<BooleanInput source="floor_bandit_enabled" label="Enable Dynamic Floor Bandit" helperText="Enable Dynamic Floor Bandit. Requires an Experiment and Publisher filter to be configured." />
					<BooleanInput source="referer_defaulting_enabled" label="Enable Referer Defaulting" helperText="Enable referer defaulting experiment. Requires an Experiment to be configured." />
					<BooleanInput source="video_pod_enabled" label="Enable Video Ad Pods" helperText="Serve the top 2 video bids as one sequenced VAST pod instead of discarding the runner-up. Applies to prebid.js client requests; never to GAM-partner requests, and to OpenRTB only when the OpenRTB flag below is also on. Scoped by this rule's targeting - one enabled rule pods every video bid on a matching request, so slot 2 may go to any bidder. Player support varies and is undocumented by any vendor - watch slot-2 render rate after enabling. Clearing this is the kill switch." />
					<BooleanInput source="video_pod_ortb_enabled" label="Enable Video Ad Pods on OpenRTB" helperText="Extends pods to the OpenRTB endpoints, which are excluded by default. There the pod is copied straight into bid.adm: a caller that asked for one ad per imp may reject a multi-Ad creative and lose the WHOLE bid, not just slot 2, and it books one impression at whatever price we report however many ads play. Prove slot-2 render rate on prebid.js first, then enable here with First price pricing. No effect unless Enable Video Ad Pods is also on." />
					<SelectInput source="video_pod_pricing_mode" label="Video Pod Pricing" allowEmpty helperText="First price reports only the winning bid, crediting the publisher exactly what they get today with no revenue exposed if slot 2 never renders - the safe default for a first test. Compound reports P1+P2, giving the publisher the pod upside while NoBid carries the risk that slot 2 doesn't render. On OpenRTB, Compound also prices the bid itself on two renders the caller will never confirm. Leave empty for first price." choices={utils.POD_PRICING_MODES} style={{ maxWidth: 256 }} />

					<SectionHeader title="Experiment" />
					<ReferenceInput label="Experiment"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						source="experiment_id"
						reference="experiments"
						basePath='experiments'
						allowEmpty
						emptyText="- None -">
						<SelectInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) at ${record.pace}%` : ""} optionValue="code" style={{ maxWidth: 256 }}/>
					</ReferenceInput>
				</Box>
			</FormTab>
			<FormTab label="Filters">
        <Filters {...props}/>
			</FormTab>

			<FormTab label="Creative Settings">
				<Card style={{ width: '100%' }} raised>
					<CardHeader title="Creative Settings" />
					<CardContent>

						<ReferenceArrayInput label="Creative"
							perPage={15}
							sort={{ field: 'name', order: 'ASC' }}
							filterToQuery={searchText => ({ search_name: searchText })}
							source="creatives"
							reference="creatives"
							basePath='creatives'
						>
							<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) [${record.adsize}]` : ""} optionValue="code" style={{ width: '50%' }} />
						</ReferenceArrayInput>

					</CardContent>
				</Card>
			</FormTab>

			<FormTab label="Price Rules">
				<NumberInput source="price_rules.first_price_scale" label="Price Adjustment" helperText="The prediction first price is multiplied by this number." />
				<NumberInput source="price_rules.second_price_scale" label="Second Price Adjustment" helperText="The prediction second price is multiplied by this number." />
				<NumberInput source="price_rules.auction_price_scale" label="Auction Price Adjustment" helperText="The price we send to the client (Prebid or Platform Tag) is multiplied by this number." />
				<NumberInput source="price_rules.price_level_scale" label="Price Level Adjustment" helperText="The price we send to GAM/DFP is multiplied by this number." />
				<NumberInput source="price_rules.second_price_scale_relative_to_first" label="Second Price Adjustment Relative to First" style={{ width: '400px' }} />
			</FormTab>

			<FormTab label="Creative Extensions">
				<ArrayInput source="tags">
					<SimpleFormIterator>
						<TextInput source="name" label="Name" validate={required()} style={{ width: '400px' }} />
						<TextInput source="description" label="description" multiline style={{ width: '400px' }} />
						<SelectInput label="Position relative to the creative" choices={
							[
								{ id: 'PREPEND', name: 'Before creative' },
								{ id: 'APPEND', name: 'After creative' }
							]
						}
							source="position"
						/>
						<br />
						<h5 style={{ width: '90%' }}>
							Double-quotes are not allowed in the content. Please escape them or use single quotes when possible.
		    	</h5>
						<div style={{ width: '90%' }}>Available Macros:<br />
		    	DIV_ID, ADUNIT_PATH, AD_SIZE, AD_SIZES, AD_SIZE_STRING, AD_SIZES_CLEANED, BIDDER_ID, BIDDER_NAME, PRICE, PRICE_BUCKET, BID_ID, SLOT_ID, CHANNEL_ID, BIDDER_SIZE_ID, BIDDER_SITE_ID, WIDTH, HEIGHT, SITE, PLACEMENT, PUBLISHER, ENVIRONMENT, PAGE_URL, IMPRESSION_TYPE, COPPA_SNIPPET, CHANNEL, PAGE_LOCATION, RANDOM, REGION, CREATIVE_ID, ADVERTISER_DOMAIN
		    	</div>
						<TextInput multiline label="Tag HTML content"
							validate={required()}
							source="content"
							helperText="Tag content in HTML format"
							style={{ width: '90%' }}
						/>
					</SimpleFormIterator>
				</ArrayInput>
			</FormTab>

		</TabbedForm>
	</Create>
	);
};
